<script>
	// Stores 
	import { 
		textSite,
	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Legislação';
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">
		<p>LEI DO CONDOMÍNIO (arts. 1º a 27)</p>
		<p>Link: <a href="http://www.planalto.gov.br/ccivil/Leis/L4591.htm">http://www.planalto.gov.br/ccivil/Leis/L4591.htm</a></p>
		<p>NOVO CÓDIGO CIVIL BRASILEIRO (arts. 1.331 a 1.358)</p>
		<p>Link: <a href="http://www.planalto.gov.br/ccivil_03/Leis/2002/L10406.htm">http://www.planalto.gov.br/ccivil_03/Leis/2002/L10406.htm</a></p>
	</div>
</section>